import { BannerOverlay } from "@/components/BannerOverlay/BannerOverlay";
import { SectionTitleAndSubtitle } from "@/components/SectionTitleAndSubtitle";
import { Box, Container, Grid } from "@mui/material";
import { RegimeItem } from "./RegimeItem";
import { regimesData } from "./utils";

export function TaxRegimesWeServe() {
  return (
    <Box
      sx={{
        position: "relative",
        backgroundImage: `url(business_meeting.jpg)`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundAttachment: "fixed",
        "@supports (-webkit-touch-callout: none)": {
          backgroundAttachment: "scroll !important",
        },
      }}
    >
      <BannerOverlay />
      <Box component="section" sx={{ paddingY: 8, position: "relative" }}>
        <Container>
          <SectionTitleAndSubtitle
            title="Regimes Tributários que Atendemos"
            subTitle="Oferecemos suporte completo para a sua melhor opção fiscal."
            textAlign="center"
            color="white"
          />

          <Grid container spacing={4} sx={{ marginTop: 3, justifyContent: "center" }}>
            {regimesData.map((regime) => (
              <RegimeItem key={regime.name} name={regime.name} description={regime.description} icon={regime.icon} />
            ))}
          </Grid>
        </Container>
      </Box>
    </Box>
  );
}
